import React, { useState } from 'react';
import styled from 'styled-components';

const CodeBlockContainer = styled.div`
  position: relative;
  margin: 20px 0;
`;

const CodeBlock = styled.pre`
  background-color: #2d2d2d;
  color: #f8f8f2;
  padding: 20px;
  border-radius: 6px;
  overflow-x: auto;
  font-family: 'Courier New', Courier, monospace;
  line-height: 1.5;
  font-size: 14px;
  white-space: pre-wrap;
`;

const CopyButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

interface CodeSnippetProps {
  code: string;
}

const CodeSnippet: React.FC<CodeSnippetProps> = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <CodeBlockContainer>
      <CodeBlock>{code}</CodeBlock>
      <CopyButton onClick={handleCopy}>
        {copied ? 'Copiado!' : 'Copiar'}
      </CopyButton>
    </CodeBlockContainer>
  );
};

export default CodeSnippet;
